<template>
<div>

<navbar class="grid h100"></navbar>

  <div class="blocco h100 " style="justify-content: flex-start;">  
   
    <circle4 v-if="loading"></circle4>


    <div class="spacer sm"></div>

    <div class="blocco row" style="align-items: flex-start; overflow: auto;">
      <div v-for="(key, year) in yearsgrouped" style="padding: 0 20px;">
        <h2>{{year}}</h2>
        <div class="label" v-for="house in housesgrouped(key)" v-bind:class="{ error: house.length < 28, success: house[0].finished }">{{haus[house[0].struktur]}} <span v-if="house[0].finished" class="fa fa-check"></span></div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import {Circle4} from 'vue-loading-spinner'
  import _ from 'lodash'
  // import router from './../router'
  // var host = 'https://bench.node.systems'
  // var host = 'http://localhost'
  var host = process.env.ROOT_HOST
  export default {
    name: 'home',
    data () {
      return {
        loading: true,
        profile: JSON.parse(localStorage.profile),
        ratioquests: '',
        rat: {},
        haus: {}
      }
    },
    components: {
      Circle4,
      Navbar
    },
    methods: {
      go: function () {
        console.log('go')
      },
      calcratio: function (house) {
        // console.log(house)
        // var total = 0
        var ratiovalues = 0
        house.forEach((house, index) => {
          console.log(house)
          if (house.ratiovalues[0].perc) {
            ratiovalues += 1
          }
          if (house.ratiovalues[0].euro) {
            ratiovalues += 1
          }
          if (house.ratiovalues[0].number) {
            ratiovalues += 1
          }
        })
        return ratiovalues
      },
      fullratio: function () {
        // console.log(this.value)
        this.loading = true
        this.$http
          .get(host + ':44534/api/ratios',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.ratioquests = data.body.ratioquests
            // console.log(data.body.ratioquests)
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getHouses: function () {
        this.$http
          .get(host + ':44534/api/houses',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body.houses)
            data.body.houses.forEach((house, index) => {
              // console.log(house)
              // var id = house._id
              this.$set(this.haus, house._id, house.struktur)
            })
          }, (error) => {
            console.log(error)
          })
      },
      housesgrouped: function (year) {
        // console.log(year)
        return _.groupBy(year, 'struktur')
      }
    },
    computed: {
      yearsgrouped: function () {
        return _.groupBy(this.ratioquests, 'year')
        // this.rat.push(_.groupBy(this.ratioquests, 'year'))
      }
    },
    beforeMount () {
    },
    mounted () {
      this.fullratio()
      this.getHouses()
      // this.calcratio()
      // this.loading = false
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/Home.vue